<template>
  <div class="list">
    <ul>
      <li v-for="(item,a) in Data" :key="a">
        <a href @click="toDetail($event,item,item.Id)"  style="max-width:70%">{{item.Title}}</a>
        <span class="rightfloat list_date" v-if="!datelist">[{{item.DateCreate}}]</span>
        <i class="icon iconfont highred" style=" font-size: 22px;" v-if="a < 3 && flagture == 2">&#xe62a;</i>
      </li>
    </ul>
    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Data: []
    };
  },
  props: ["params","datelist","flagture"],
  mounted() {
    this.$store
      .dispatch("_getActor", this.params)
      .then(res => {
        this.Data = res.data.Data;
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods:{
    toDetail(e, x, id) {
      e.preventDefault();
      if (x.DataType == "Text" || x.DataType == "文字") {
        let routeUrl = this.$router.resolve({
          path: "/NewsDetails?ItemId=" + id
        });
        window.open(routeUrl.href, "_blank");
      } else if (x.DataType == "File" || x.DataType == "文件") {
        if (x.FileGUID == "") {
          alert("下载失败,未发现文件");
          return;
        }
        var aa = x.FileGUID;
        var ac = x.Title;
        this.OpenGUIDFile(aa);
      } else if (x.DataType == "Link" || x.DataType == "链接") {
        window.open(x.Url, "_blank");
      }
    },
    OpenGUIDFile(FileGUID) {
      this.$store.dispatch('_OpenGUIDFile', {
          FileGUID:FileGUID
        }).then(res=>{
           if (res.data.IsSuccess) {
             this.$DownloadBase64File(res.data.Guid, 1);
           } else {
             this.$error(res.data.Message);
           }
         }).catch(error=>{
           console.log(error)
        })
    }
  }
};
</script>
<style >

.list ul {
    padding: 10px 5px;
}
.list li {
    height: 32px;
    line-height: 32px;
    background: url("../../../assets/images/arrow.gif") 7px 14px no-repeat;
    padding-left: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
}
li {
    list-style-type: none;
}

a{
    color: #333;
    text-decoration: none;
}
</style>